// extracted by mini-css-extract-plugin
export default {"bar":"NotificationBar_bar__qNxfu"};